'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.beginningOfYear;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/beginningOfYear.js
// module id = 480
// module chunks = 0